import React from "react";
import { Box, Stack } from "@mui/material";
import Heading6 from "../typography/heading-06";
import Body3 from "../typography/body-03";
import { VERBIAGE_CONSTANTS } from "../../utils/verbiage.constants";
import styles from "./index.module.scss";

// LC-696 / PathA-5.10, R-11: "AURA is evaluating your loan". The bar is not tied to
// real progress — it moves fast, then slows, never reaches the end and shows no
// percentage. Under prefers-reduced-motion it is a steady indicator (see SCSS).
// Built in SCSS rather than MUI LinearProgress, which CLAUDE.md rules out.
const AuraProgress = ({ text = VERBIAGE_CONSTANTS.AURA_EVALUATING, detail }) => (
	<Stack direction="column" gap={1} className={styles.root} role="status" aria-live="polite">
		<Heading6 text={text} fontType="semibold" />
		{detail && <Body3 text={detail} extraClass={styles.detail} />}
		<Box className={styles.track} role="progressbar" aria-label={text} aria-busy="true">
			<Box className={styles.bar} />
		</Box>
	</Stack>
);

export default AuraProgress;
